import { Row } from 'reactstrap';

import RightHeader from './rightbar';
import styles from './header.module.scss';

const Header = ({ className = '' }) => {
  return (
    <div className={`page-header ${styles['admin-page-header']} ${className}`}>
      <Row className={`${styles['agrisud-header']} header-wrapper m-0`}>
        <RightHeader />
      </Row>
    </div>
  );
};

export default Header;
